<template>
  <div class="success-container-1" v-if="show">
    <img :src="require('@/assets/images/icon_success.png')" alt="" v-if="info.type=='success'"/>
    <img :src="require('@/assets/images/icon_successx.png')" alt="" v-if="info.type=='fail'"/>
    <span class="span1" v-if="info.title">{{info.title}}</span>
  </div>
</template>
<script>
export default {
	props:['title'],
  data(){
    return {
      show:false,
      info:{
        type:'success',
        title:'修改成功'
      }
      
    }
  },
  created(){
    
  },
	methods:{
		isShow(){
			if(this.show){
				
			}else{
				this.show = true
				setTimeout(()=>{
				  this.show = false;
				},2000)
			}
		}
	}
	
}
</script>
<style lang="scss" scoped>
.success-container-1{
   z-index: 20010;
  background: #ffffff;
  @include abs-c;
  position: fixed;
  min-height: 104px;
  min-width: 104px;
  border-radius: 8px;
  box-shadow: 0px 0px 13px #fff3f3;
  @include flex-d-c;
  font-size: 14px;
  color: #808080;
  align-items: center;
  padding: 20px;
  .span1{
    width: 100px;
    
    text-align: center;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/plugins/toast.vue